document.querySelectorAll('.video-link video').forEach(video => {
    video.addEventListener('click', function() {
        // Hide controls
        this.removeAttribute('controls');
        // Set the video to autoplay and loop again on click
        this.play();
    });

    // Automatically mute and loop the video when it plays
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
});
